{
    "warning": "AVISO!",
    "message": "Não insira nem cole códigos que você não entende.\nO uso deste console pode permitir que invasores se passem por você e roubem suas informações usando um ataque chamado Self-XSS."
}
